import { SelectIntegrationTypeWebComponent } from './component/SelectIntegrationTypeWebComponent';
import { WEB_COMPONENT_SELECT_INTEGRATION } from '../../webcomponents.constants';

export { SelectIntegrationTypeWebComponent };

window.customElements.define(WEB_COMPONENT_SELECT_INTEGRATION, SelectIntegrationTypeWebComponent);
